import { createContext, type MutableRefObject, useContext } from 'react';

export const DataTableRefContext =
  createContext<MutableRefObject<HTMLTableElement | null> | null>(null);

export const useDataTableRefContext = () => {
  const dataTableRef = useContext(DataTableRefContext);

  if (!dataTableRef) {
    throw new Error(
      'useDataTableRefContext must be used within a <DataTable /> component',
    );
  }

  return dataTableRef;
};
